function showPrice(price) {
  if (price === 0) {
    return "面议";
  } else {
    return `¥${(price / 100).toFixed(2)}`;
  }
}

export default showPrice;
